import React, { CSSProperties, FC, ReactElement } from 'react'

import {
  IMobileBackBar,
  MobileBackBar,
} from '../mobile-back-bar/mobile-back-bar'
import MobileCustomPage from '../mobile-custom-page/mobile-custom-page'

interface IMobileBackPage {
  backPageProps: IMobileBackBar
  Footer?: ReactElement
  style?: CSSProperties
  isModal?: boolean
  isOpen?: boolean
  navBar?: ReactElement
  children: React.ReactNode
}

const MobileBackPage: FC<IMobileBackPage> = ({
  children,
  backPageProps,
  Footer,
  style = {},
  isModal = false,
  isOpen = true,
  navBar,
}) => (
  <MobileCustomPage
    navBar={navBar || <MobileBackBar {...backPageProps} />}
    Footer={Footer}
    style={style}
    isModal={isModal}
    isOpen={isOpen}
  >
    {children}
  </MobileCustomPage>
)

export default MobileBackPage
